// Import views to route to here

export default [
  // Add admin-only pages here
].map(route => ({
  ...route,
  meta: {
    auth: true,
    roles: ['admin']  // Only for admins, including non-released features
  }
}))